module.exports = __webpack_public_path__ + "img/logo-red.8ba42c09.png";